import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/pix";
import Loading from "@/atomic/atoms/Loading";
import { getFormattedValue } from "@/utils/functions";
import { Suspense } from "react";
import Modal from "@/atomic/atoms/Modal";
import useI18n from "@/hooks/useI18n";

export default function RechargePixView({
  isLoading,
  goBack,
  goHome,
  payment,
  pixCode,
  pixImage,
  copyCode,
  isVisibleModal,
  toggleModal,
  share,
  error,
  codeExpiration,
  total,
  plates,
  toggleError,
  timer,
  showPaymentErrorModal,
  togglePaymentErrorModal,
}: PropsView) {
  const { t } = useI18n();

  const renderModal = () => (
    <div className="fixed flex flex-1 top-0 left-0 right-0 bottom-0 z-20 w-full bg-black/30 justify-center items-start text-black h-full min-h-screen">
      <div className="relative w-full max-w-[calc(480px)] max-h-full mt-[calc(100px)]">
        <div className="relative bg-white rounded-2xl shadow p-5">
          <div className="w-full flex flex-col items-center pb-3">
            <img
              src={"/icon-checked.png"}
              width={80}
              height={80}
              alt="ícone sucesso"
              className="mt-6"
            />
            <p className="self-center text-lg mt-3 font-bold mb-3">{t("pages:paymentPix:title")}</p>
            <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
            <p className="text-sm mt-2 text-center">{t("pages:paymentPix:modalWarning")}</p>
            <button type="button" onClick={toggleModal} className="mt-3 mb-[calc(10px)] bg-black border p-2 rounded-lg h-[calc(60px)] text-white w-full">{t("pages:paymentPix:gotIt")}</button>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="h-full relative">
      <Header
        title={t("pages:paymentPix:payment")}
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] text-black h-form">
        <article className="h-full flex flex-col w-[calc(480px)] max-w-full">
          <div className="flex-1 overflow-y-auto pb-4">
            {error && <div className="flex w-full flex-col">
              <h2 className="text-2xl text-center font-bold">{t("pages:paymentPix:errorDescription")}</h2>
              <h3 className="text-lg text-center">{t("pages:paymentPix:clickButton")}</h3>
            </div>}
            {!error && <div className="flex w-full flex-col">
              <h2 className="text-2xl font-bold">{t("pages:paymentPix:title")}</h2>
              <div className="mt-3 bg-white rounded-lg overflow-hidden">
                <div className="w-full p-4">
                  <p className="text-base font-bold text-[#525252] mb-3">{t("pages:paymentPix:resume")}</p>
                  <div className="mt-3 flex w-full">
                    <p className="text-sm text-gray-600 w-1/2">{t("pages:paymentPix:plate")}</p>
                    <p className="text-sm text-black font-medium w-1/2 uppercase text-right">{plates}</p>
                  </div>
                  <div className="mt-3 flex w-full">
                    <p className="text-sm text-gray-600 w-1/2">{t("pages:paymentPix:value")}</p>
                    <p className="text-sm text-black font-medium w-1/2 text-right">{getFormattedValue(total)}</p>
                  </div>
                  <div className="mt-3 flex w-full">
                    <p className="text-sm text-gray-600 w-1/2">{t("pages:paymentPix:expiration")}</p>
                    <p className="text-sm text-black font-medium w-1/2 text-right">{codeExpiration}</p>
                  </div>
                </div>
                {!isLoading && <div className="flex w-full p-4 bg-[#E6E6E6] ">
                  <p className="text-base font-semibold text-gray-700 w-1/2">{t("pages:paymentPix:orderValue")}</p>
                  <p className="text-2xl font-bold text-gray-800 w-1/2 text-right">{getFormattedValue(total)}</p>
                </div>}
              </div>

              {timer && (
                <div className="flex justify-center items-center mt-4 mb-4 text-lg">
                  <span className="text-base font-medium">{t("pages:paymentPix:paymentProcess")}&nbsp;</span>
                  <span className="text-lg font-mono font-bold text-black">{timer}</span>
                </div>
              )}

              {pixImage && <div className="mt-3 w-full flex justify-center">
                <img 
                  src={`data:${pixImage?.type};base64, ${pixImage?.image}`} 
                  alt="Código pix"
                  className="w-40 max-h-40"
                />
              </div>}
              
              <p className="mt-5 text-sm">{t("pages:paymentPix:description")}</p>
              <div className="rounded-lg bg-gray-200 p-3 mt-2 w-full">
                <p className="break-words text-sm">{pixCode}</p>
              </div>
            </div>}
          </div>
          <div className="mt-auto pt-4">
            {error && <button type="button" onClick={payment} className="bg-black border border-black text-white p-2 rounded-lg h-[calc(60px)] w-full flex items-center justify-center">
              {t("pages:paymentPix:tryAgain")}
            </button>}
            {!error && <div>
              <button type="button" onClick={copyCode} className="bg-black border p-2 rounded-lg h-[calc(60px)] w-full flex items-center justify-center">
                <img
                  src={"/svg/icon-copy-white.svg"}
                  width={20}
                  height={20}
                  alt="ícone copiar"
                />
                <span className="ml-2 text-white text-base">{t("pages:paymentPix:buttonCopy")}</span>
              </button>
              <button type="button" onClick={share} className="mt-2 bg-transparent border border-black p-2 rounded-lg h-[calc(60px)] w-full flex items-center justify-center">
                <img
                  src={"/svg/icon-share-black.svg"}
                  width={20}
                  height={20}
                  alt="ícone copiar"
                />
                <span className="ml-2 text-black text-base">{t("pages:paymentPix:buttonShare")}</span>
              </button>
            </div>}
          </div>
        </article>
      </main>
      {isVisibleModal && renderModal()}
      {isLoading && <Loading />}
      {error && <Suspense fallback={null}>
        <Modal 
          title={t("pages:warning")}
          message={t("pages:paymentPix:paymentError")}
          actionMessage={t("pages:common:yes")}
          actionSecondMessage={t("pages:common:no")}
          action={() => {
            toggleError();
            payment();
          }}
          actionSecond={() => {
            toggleError();
            goBack();
          }}
        />
      </Suspense>}
      {showPaymentErrorModal && <Suspense fallback={null}>
        <Modal 
          title={t("pages:warning")}
          message={t("pages:paymentPix:paymentError")}
          actionMessage={t("pages:common:close")}
          action={() => {
            togglePaymentErrorModal();
            goHome();
          }}
          actionSecond={() => {
            togglePaymentErrorModal();
            goHome();
          }}
        />
      </Suspense>}
    </div>
  );
}
